import { withTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import styled from "styled-components";
import { PlusOutlined } from '@ant-design/icons';

import { get } from "library/endpoints";
import Text from "components/Text";
import Title from "components/Title";
import IkomModal from "components/IkomModal";
import IkomMountQuotationsModal from "components/IkomMountQuotationsModal";

import { setGlobalSelectedMount, toggleModalEffectCreation, setQuotationBasket, setMountQuotations } from "modules/ui/actions";
import { isPremium } from "utils";
import ImageError from "./ImageError";
import useTheme from "hooks/useTheme";
import useUserIris from "hooks/useUserIris";

const ImageWrapper = styled.div`
  text-align: center;
  background: black;
  height: 140px;
  margin: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 0 5px grey;
  border-radius: 10px;
  position: relative;
  cursor: pointer;

  > image {
    width: 90%;
  }
`;

/**
 * Home
 * @param {*} props 
 * @returns 
 */
const Home = (props) => {
  const [userMounts, setUserMounts] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [selectedMount, setSelectedMount] = useState(null);
  const [displayMountQuotationModal, setDisplayMountQuotationModal] = useState(false);
  const [selectedMountQuotation, setSelectedMountQuotation] = useState(null);
  const {userIris} = useUserIris();

  const {theme} = useTheme();

  useEffect(() => { 
    if (!props.auth.token) {
      props.push('/')
    }
    fetchMounts();
    fetchMountQuotations();
  }, []) // eslint-disable-line

  const fetchMounts = async () => {
    try {
      const { data } = await get(`/frontend/effect-processing`);
      setUserMounts(data)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchMountQuotations = async () => {
    try {
      const response = await get(`/frontend/mount-quotations`);
      props.setMountQuotations(response.data);
    } catch (error) {
      console.log(error)
    }
  }

  const handleOnDownload = (url) => {
    window.open(url);
  }
  
  const handleOnSelectMount = (mount) => {
    props.setGlobalSelectedMount(mount);
    props.push(`/configurator`)
  }

  const handleOnCreatEffect = () => {
    props.toggleModalEffectCreation(true);
    props.push('/configurator');
  }

  return (
    <>
      {
        props.ui.quotationBasket.length > 0 && (
          <div style={{ width: '100%', background: '#53b297', padding: 10, cursor: 'pointer' }} onClick={() => props.push(`/quotations`)}>
            <Text color="white" align="center" underline>Un devis vous a été envoyé par votre boutique, cliquez ici pour le consulter</Text>
          </div>
        )
      }

      {
        displayModal && (
          <IkomModal 
            mount={selectedMount} 
            handleOnClose={() => setDisplayModal(false)}
            handleOnDownload={handleOnDownload}
            handleOnSelectMount={handleOnSelectMount}
          />
        )
      }

      {
        displayMountQuotationModal && (
          <IkomMountQuotationsModal 
            mount={selectedMountQuotation} 
            handleOnClose={() => {setSelectedMountQuotation(null); setDisplayMountQuotationModal(false)}}
            handleOnDownload={handleOnDownload}
            fetchMountQuotations={fetchMountQuotations}
          />
        )
      }

      <div
        style={{ width: '100%',  }}
      >
        <Title align="center" style={{ paddingTop: 20 }}>Bienvenue sur l'espace client {props.auth?.tenant?.company}</Title>       
        
        {
          userIris.length > 0 ? (
            <>
              <Text color="black" size={14} align="center" style={{ paddingTop: 20, marginBottom: 20 }}>Voici vos photos</Text>       
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>

                {
                  isPremium(props.auth.tenant) && (
                    <ImageWrapper className="button-color">
                      <div style={{ width: 125, cursor: 'pointer' }} onClick={handleOnCreatEffect}>
                        <PlusOutlined style={{ fontSize: 35, color: 'white' }} />
                        <Text color="white" align="center">Créer un nouveau montage</Text>
                      </div>
                    </ImageWrapper>  
                  )
                }

                {
                  props.ui.mountQuotations.filter((mount) => mount.output).map((mount) => (
                    <ImageWrapper
                      onClick={() => { setSelectedMountQuotation(mount); setDisplayMountQuotationModal(true); }}
                    >
                      <div style={{ background: '#870c0c', color: 'white', position: 'absolute', width: 125, bottom: 0, fontSize: 14, borderRadius: '0 0 3px 3px' }}>A valider</div>
                      <img 
                        src={`${process.env.REACT_APP_S3_FILES_URL}thumbnails/${mount.output}`} 
                        style={{ width: 125 }} 
                        alt={`Votre montage`}
                      />
                    </ImageWrapper>
                  ))
                }

                {
                  userMounts.filter((m) => !m._mount_quotation_tempId).map((mount) => (
                    <ImageWrapper
                      onClick={() => { setSelectedMount(mount); setDisplayModal(true); }} alt={`Votre montage`}
                    >
                      <ImageError 
                        thumbnail={`${process.env.REACT_APP_S3_FILES_URL}thumbnails/${mount.output}`}
                        output={`${process.env.REACT_APP_S3_FILES_URL}${mount.output}`}
                        style={{ width: 125 }} 
                        alt={`Votre montage`}
                      />
                    </ImageWrapper>
                  ))
                }
              </div>
              
            </>
          ) : (
            <Text color="black" size={14} align="center" style={{ paddingTop: 20, marginBottom: 20 }}>Vos prises de vue ne sont pas encore disponibles</Text>       
          )
        }


        
        {
          theme && theme.theme.footer && (
            <div dangerouslySetInnerHTML={{ __html: theme.theme.footer }} />
          )
        }

        {
          theme && theme.theme?.frontend_iframe && (
            <iframe 
              src={theme.theme.frontend_iframe} 
              style={{ border: 'none', width: '100%', height: 500 }} 
              title="ikomiris-infos"
            />
          )
        }

      </div>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui
})

const dispatchToProps = {
  push,
  setGlobalSelectedMount,
  toggleModalEffectCreation,
  setQuotationBasket,
  setMountQuotations
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Home))